<template>
    <app-layout title="Beheer">
        <template #header>
            <page-title title="Categorieën" />
        </template>

        <template #pageContent>
            <div class="flex justify-between w-1/2">
                <TableSearch tableId="configuration-assignment-type-categories" :values="assignmentTypeCategories" class="w-1/2" placeholder="Zoeken"/>

                <Modal buttonText="Toevoegen" buttonClass="add" @modalClosed="modalClosed" ref="modal">
                    <h2>Opdrachttype categorie {{ modalTitleAction }}</h2>
                    <Form @submitted="handleSubmit" class="w-full">
                        <Input type="hidden" name="id" v-model="form.id" />
                        <Input type="text" label="Categorie" name="name" :required="true" v-model="form.name" :error="form.errors.name" />

                        <div class="inline-block self-end mt-4">
                            <Button text="Annuleren" buttonClass="secondary" data-modal="close" />
                            <Button
                                :text="modalTitleAction"
                                buttonType="submit"
                                buttonClass="save"
                                class="capitalize"
                                :loading="form.processing"
                            />
                        </div>
                    </Form>
                </Modal>
            </div>

            <Table id="configuration-assignment-type-categories" :values="assignmentTypeCategories" class="w-1/2">
                <thead>
                <Th id="name">Categorie</th>
                <Th :sort="false" class="w-[75px]"></Th>
                </thead>
                <tbody>
                <tr v-for="(assignmentTypeCategory, key) in state.sortedValues['configuration-assignment-type-categories']" :key="key">
                    <Td>{{ assignmentTypeCategory.name }}</Td>
                    <Td>
                        <Button buttonClass="edit" size="small" title="Bewerken" @click="updateAssignmentTypeCategory(assignmentTypeCategory)" />
                        <Button buttonClass="delete" size="small" title="Verwijderen" @click="deleteAssignmentTypeCategory(assignmentTypeCategory)" />
                    </Td>
                </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Modal from '@/Components/Modal.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'

import store from '@/store'
import { useForm } from "@inertiajs/inertia-vue3"
import { ref } from "vue"
import { Inertia } from "@inertiajs/inertia"

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Modal,
        Form,
        Input,
    },
    props: [
        'assignmentTypeCategories',
    ],
    setup (props)
    {
        let modalTitleAction = ref('toevoegen') //of bewerken
        const modal = ref(null)

        const form = useForm({
            id: null,
            name: null,
        })

        function updateAssignmentTypeCategory(assignmentTypeCategory)
        {
            form.id = assignmentTypeCategory.id
            form.name = assignmentTypeCategory.name

            modalTitleAction.value = 'bewerken'
            modal.value.show = true
        }

        function deleteAssignmentTypeCategory(assignmentTypeCategory)
        {
            if (!confirm('Bent u zeker dat u deze categorie wil verwijderen?'))
                return

            Inertia.delete('/configuration/assignment_types/assignment_type_categories/' + assignmentTypeCategory.id)
        }

        function handleSubmit()
        {
            if (modalTitleAction.value === 'toevoegen')
            {
                //Store
                form.post('/configuration/assignment_types/assignment_type_categories', {
                    onSuccess: () => {
                        modal.value.show = false
                        modalClosed()
                    },
                })
            } else {
                //Update
                form.put('/configuration/assignment_types/assignment_type_categories/' + form.id, {
                    onSuccess: () => {
                        modal.value.show = false
                        modalClosed()
                    },
                })
            }
        }

        function modalClosed()
        {
            form.clearErrors()
            form.reset()
            modalTitleAction.value = 'toevoegen'
        }

        return {
            state: store.state,
            ...store,
            form,
            handleSubmit,
            modal,
            modalClosed,
            modalTitleAction,
            updateAssignmentTypeCategory,
            deleteAssignmentTypeCategory,
        }
    },
}

</script>
